import {
  MRT_ColumnDef,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"
import { useAppSelector } from "../../../redux/hooks"
import { Box } from "@mui/material"
import { defaultTableProps } from "../ResourceBudgetTable/constants"
import SortIcon from "@mui/icons-material/Sort"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { setHuddleSummaryKeyMetricsRows } from "../../../redux/slices/huddleSlice"
import { assignTableId } from "../../../../helper/utils"

type tableProps = {
  columns: MRT_ColumnDef<any>[]
  data: {}[]
  enableEditing?: boolean
  blurHandler?: any
  flex?: any
}

export const HuddleSummaryKeyMetricsTable = (props: tableProps) => {
  const dispatch = useDispatch()

  const { columns, data, enableEditing, blurHandler, flex } = props
  const loading = useAppSelector((state) => state.app.loading)

  const maevaSelectedPracticesNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll
  })

  const table = useMaterialReactTable({
    ...defaultTableProps,
    columns: columns,
    data: data,
    enableSorting: false,
    enableMultiSort: false,
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        backgroundColor: "#1A428A",
        color: "#fff",
        fontWeight: "bold",
        height: "32px",
        boxShadow: " #00000022 1.95px  0px 2.6px",
      },
    },
    muiTableContainerProps: {
      sx: {
        borderRadius: "none",
        height: "fit-content",
        maxWidth: `calc(45vw - 10px)`,
      },
    },
    icons: {
      ArrowDownwardIcon: () => <SortIcon sx={{ color: "#fff", ml: "7px" }} />,
    },
    muiTableBodyCellProps: ({ cell, table }) => {
      return {
        align: "center",
        onClick: () => table.setEditingCell(cell),
        sx: {
          height: "48px",
          boxShadow: "#00000022 1.95px 0px 2.6px",
          color: "black",
        },
      }
    },
    state: {
      isLoading: loading,
      columnVisibility: { Actions: false },
      // columnPinning: {
      //     left: ["provider_name", "provider_type"],
      // },
    },
  })

  useEffect(() => {
    dispatch(
      setHuddleSummaryKeyMetricsRows(table?.getPrePaginationRowModel().rows),
    )
  }, [maevaSelectedPracticesNoAll])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "fit-content",
        // flexGrow: 1,
        // position: "relative",
        // border: "1px solid red"
        // width: "fit-content",
        // overflowX: "scroll"
      }}
    >
      <MaterialReactTable table={table} />
    </Box>
  )
}
